import React from 'react'
import cx from 'classnames'
import { connect } from 'redaction'

import Image from 'components/_new/ui/Image/Image'
import ZinaImage from 'components/_new/ui/ZinaImage/ZinaImage'

import s from './ProductImage.scss'


// TODO add LazyImage

const ProductImage = ({ className, height, aspectRatio, src, alt, isZinaEnabled }) => {
  let imgNode

  if (isZinaEnabled) {
    imgNode = (
      <ZinaImage>
        <img
          key={src}
          src={src && src.replace(/cdn2?\.scentbird/g, 'cdn2.scentbird')}
          alt={alt}
        />
      </ZinaImage>
    )
  }
  else {
    imgNode = (
      <Image src={src} x2 x3 h={height} alt={alt} />
    )
  }

  return (
    <div className={cx(s.productImage, className)}>
      {imgNode}
      <div className={s.placement} style={{ paddingBottom: `${Math.round(100 / aspectRatio)}%` }} />
    </div>
  )
}

ProductImage.propTypes = Image.propTypes

ProductImage.defaultProps = {
  height: 100,
  aspectRatio: 1,
}


export default connect({
  isZinaEnabled: (state) => {
    const { routing: { location: { query } } } = state

    return Boolean(query.disableInstart)
  },
})(ProductImage)
